import {SingleAccountOrderDialogComponent, singleAccountOrdersDialog} from "./SingleAccountOrderDialogComponent";

export default function() {
    return angular
        .module("tfApp.portfolio.single-account-equity-dialog", [])
        .component(SingleAccountOrderDialogComponent, singleAccountOrdersDialog())
        .name;
}
